import it from './it.js'
import en from './en.js'
// import es from './it.js' // copy and translate to have the same structure

export const languages = {
     it: it,
     en: en,
}